<template>
  <Modal
    :show-close="false"
    :close-on-background-click="false"
    :reposition="reposition"
  >
    <template #header>
      <slot name="header" />
    </template>
    <template #default>
      <slot />
    </template>
    <template #footer>
      <div class="uk-flex uk-flex-space-between">
        <a
          class="uk-button"
          @click.prevent="$emit('cancel', true)"
        >{{ cancelText }}</a>
        <a
          class="uk-button uk-button-primary"
          @click.prevent="$emit('confirm', true)"
        >{{ confirmText }}</a>
      </div>
    </template>
  </Modal>
</template>

<script lang="ts">
import {Component, Vue, Prop} from "vue-property-decorator";
import Modal from "./Modal.vue";
@Component({
  components: {Modal}
})
export default class ConfirmationModal extends Vue {
  @Prop({default: "Cancel"}) readonly cancelText!: string;
  @Prop({default: "Confirm"}) readonly confirmText!: string;
  @Prop({default: false}) readonly reposition!: boolean;
}
</script>

<style scoped>

</style>
